export default "__VITE_ASSET__24c62fea__"